<div class="mom-container container-fluid">
    <app-split-pane-frame>
        <div headerContent class="global-header-container col-lg-12 flex-wrap">
            <div class="meeting-title-container col-lg-9" [ngStyle]="{'padding':'0px 0px 0px 8px'}">
                <h2 class="meeting-title margin-0">{{meetingTitle}} <span class="date-description body-font-size">on {{meetingDisplayDate}} at {{meetingTime}} {{tzName}} for {{duration}} minutes</span></h2>
            </div>
            <div class="icon-container col-lg-3 justify-content-end">
                <button mat-icon-button (click)="previewMinutesDialog()" tooltip="{{previewTooltip}}" triggers="hover" placement="top"
                container="body" [adaptivePosition]="false"><mat-icon>find_in_page</mat-icon></button>
                <button mat-icon-button (click)="openPreviewSelectedParticipantsDialog()"tooltip="{{draftTooltip}}" triggers="hover" placement="top"
                container="body" [adaptivePosition]="false"><mat-icon>group_add</mat-icon></button>
                <button mat-icon-button (click)="openMoMSelectApprovalDialog()"tooltip="{{approveTooltip}}" triggers="hover" placement="top"
                container="body" [adaptivePosition]="false"><mat-icon>verified_user</mat-icon></button>
                
                <div>
                    <button mat-raised-button class="mom-btn lettr-space" (click)="saveEditorContent();redirectToMeeting(meetingId,meetingIsConfidential);">RETURN TO MEETING</button>
                </div>
            </div>
        </div>
        <div leftContent [ngStyle]="{'height' : 'calc(100vh - 115px)','overflow': 'auto'}">
            <div>
                <div class="row d-flex align-items-center pd-t-12">
                    <div class="col-lg-12 d-flex px-3 justify-content-between align-items-center">
                        <a class="text-decor-r body-font-size"><h2 class = "margin-0">Minutes Taken</h2></a>
                        <button mat-raised-button class="lettr-space summarize-btn" (click)="fetchSummarizedText()">
                            Summarize
                        </button>
                    </div>
                    <form class="example-form col-lg-5 text-align-end" [ngStyle]="{'padding':'0px 11px 0px 0px', 'display':'none'}">
                        <mat-form-field class="example-full-width" [ngStyle]="{'margin':'5px 0px -10px 0px'}">
                        <span matPrefix> </span>
                        <input class="body-font-size" type="tel" matInput placeholder="Search" name= "search">
                        <button matSuffix mat-button style="    top: -7px !important;
                        left: 19px;"><mat-icon >search</mat-icon></button>
                        </mat-form-field>
                    </form>
                </div>
                <mat-card appearance="outlined" class="mom-tree-container">
                    <app-mom-tree [meetingId]="meetingId" [meetingResponse]="meetingResponse" [isApprovedTree]="isApprovedTree" (ckeditorContent)="ckeditorContent($event)" (isMinuteTask)="taskMinutePush($event)" (isMinuteNote)="noteMinutePush($event)" (isMinuteDecision)="decisionMinutePush($event)"></app-mom-tree>
                </mat-card>
            </div>
        </div>
        <div rightContent class="mar-l-10px editor-clss">
            <!-- <ng-scrollbar class="global-container" appearance = "compact" #scrollable pointerEventsMethod="scrollbar"> -->
                <div [ngStyle]="{'padding':'0px 10px'}">
                    <div [ngStyle]="{'display':'none'}">
                        <mat-form-field [ngStyle]="{'width':'100%', 'margin':'5px 0px -10px 0px'}">
                            <mat-label><p class="body-font-size">Preamble</p></mat-label>
                            <textarea class="body-font-size" matInput [ngStyle]="{'height':'25px'}" [(ngModel)] = "preamble" (blur)="savePreamble($event)"></textarea>
                        </mat-form-field>
                    </div>
                    <!-- <div [ngStyle]="{'width':'100%', 'overflow-x':'hidden !important'}"> -->
                        <mat-checkbox #selectAfterAdding [ngStyle]="{'display':'none'}"> Select tab after adding </mat-checkbox>
                        <mat-tab-group [selectedIndex]="selected.value" (selectedIndexChange)="selected.setValue($event)" (selectedTabChange)="onSelectedTabChange($event)">
                        <!-- <mat-tab *ngFor="let tab of tabs; let index = index" [label]="tab"> -->
                            <ng-container *ngFor="let tab of momList; let index = index">
                        <mat-tab class="panel-tab-controller">
                        <ng-template mat-tab-label>
                            <span [ngClass] = "selected.value == index ? 'selected-clr' : 'disable-clr'" class="span-container d-flex align-items-center" id="momTabHead{{tab.pkMomDetailId}}" (click)="viewTabContent(tab,index)">
                                <span>
                                    <span *ngIf="tab.momStatusCode =='Com'" tooltip="MOM draft shared to {{tab.momSentNames}}" triggers="hover" placement="top"
                                        container="body" [adaptivePosition]="false">
                                        <mat-icon>done</mat-icon>
                                    </span>
                                    <mat-icon *ngIf="tab.momStatusCode=='A'" tooltip="MOM shared to {{tab.momSentNames}}" triggers="hover" placement="top"
                                        container="body" [adaptivePosition]="false">done_all</mat-icon>
                                </span>
                                <span class="body-font-size outline-none lettr-space pd-tab-title" id="momTabTitle{{tab.pkMomDetailId}}" (keydown)="suppressKeyEvent($event)" (blur) = "editTabTitle($event,tab.pkMomDetailId, false,index)">{{tab.momTitle}}</span>
                                <button mat-icon-button class="tab-icon-alignment" [matMenuTriggerFor] ="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu" class="body-font-size">
                                    <!-- <button mat-menu-item class="body-font-size" (click) = "editTabTitle($event, tab.pkMomDetailId, true)">Edit</button> -->
                                    <button mat-menu-item class="body-font-size d-flex align-items-center" (click) = "editTabTitle($event, tab.pkMomDetailId, true,index)" *ngIf="tab.momStatusCode!='A'"><h3 class="text-capitalize margin-0">edit</h3></button>
                                    <button mat-menu-item class="body-font-size d-flex align-items-center" *ngIf="isAllowMomCreation"(click)="copyMomInfo(tab)">Copy</button>
                                    <button mat-menu-item class="body-font-size d-flex align-items-center" (click) = "confirmDeleteMomDetail(tab.pkMomDetailId,index)" *ngIf="tab.momStatusCode!='A'"><h3 class="text-capitalize margin-0">delete</h3></button>
                                    <button mat-menu-item class="body-font-size d-flex align-items-center" (click)="onSettemplate(tab)">
                                        <h3 class="text-capitalize margin-0">Set Template</h3>
                                    </button>
                                    <!-- <button mat-menu-item class="body-font-size" (click="copyMomInfo(tab)")>Copy Mom</button>
                                    <button mat-menu-item class="body-font-size" *ngIf="tab.momStatusCode!='A'">Delete</button> -->
                                    <!-- <button mat-menu-item>Item 2</button> -->
                                </mat-menu>
                                <button mat-icon-button
                                        class="close-icn-align" *ngIf="tab.momStatusCode!='A'"
                                        (click)="confirmDeleteMomDetail(tab.pkMomDetailId,index)">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </span>
                            <button class="example-delete-tab-button" mat-icon-button *ngIf = "index == momList.length - 1 && isAllowMomCreation" (click)="addTab(selectAfterAdding.checked,index)">
                            <mat-icon  tooltip="Add" placement = "top" triggers = "hover">
                                add
                            </mat-icon>
                            </button>
                     
                        <!-- <ng-template>
                            <button mat-icon-button>
                            <mat-icon>
                                add
                            </mat-icon>
                            </button>
                        </ng-template> -->
                        <!-- <div id="tempContent" [ngStyle]="{'display':'none'}"></div>
                        <div id="noteHtmlDiv" [ngStyle]="{'display':'none'}"></div> -->
                        <!-- <textarea debounce="500" [(ngModel)]="nodeValue" (ngModelChange)="onChange($event)" #momCkEditor name="momCkEditor" id="momCkEditor" class="body-font-size ckEditor"  data="{{nodeValue}}" [config]="ckEditorConfig" (blur)="saveEditorContent($event)" ></ckeditor> -->
                            
                        </ng-template>
                        <!-- <ckeditor [(ngModel)]="nodeValue" (ngModelChange)="onChange($event)" name="momCkEditor{{tab.pkMomDetailId}}" id="momCkEditor{{tab.pkMomDetailId}}" data="{{tab.momContent}}" [config]="ckEditorConfig"  class="body-font-size ckeditor ckEditor" ></ckeditor> -->
                        <app-adc-editor
                          class="body-font-size mom-edit"
                          [readOnly]="isApprovedTree"
                          [content]="nodeValue"
                          [config]="quillMomConfig"
                          (editorReady)="onQuillReady($event, tab)"
                          (onBlur)="onEditorBlur($event)"
                        ></app-adc-editor>
                        <!-- <ckeditor data="<p>Hello, world!</p>"></ckeditor>     -->
                        <!-- <button mat-raised-button
                                    class="example-delete-tab-button"
                                    [disabled]="tabs.length === 1"
                                    (click)="removeTab(index)">
                            Delete Tab
                            </button> -->
                        </mat-tab>
                    </ng-container>
                    <ng-container *ngIf="momList.length == 0">
                        <mat-tab class="panel-tab-controller">
                        <ng-template mat-tab-label>
                            <button (click)="addTab(selectAfterAdding.checked,0)" class="example-delete-tab-button" mat-icon-button>
                            <mat-icon tooltip="Add" placement = "top" triggers = "hover">
                                add
                            </mat-icon>
                            </button>
                        </ng-template>
                        </mat-tab>
                     </ng-container>
                        </mat-tab-group>
                </div>
        </div>
    </app-split-pane-frame>
</div>
